const colours = {
    grey01: '#454F5B',
    grey02: '#919EAB',
    grey03: '#C4CDD5',
    grey04: '#DFE3E8',
    grey05: '#F4F6F8',
    error_red: '#EF5455',
    hover_secondary_red: '#FCDDDD',
    validate_green: '#2EB996',
    hover_secondary_green: '#E0F5EF',
    primary: '#4d82b3',
    hover_primary: '#daedff'
}

export default colours;